<div class="d-flex flex-wrap gap-4">
<app-mdb-button [text]="'LOCATIONS.NEW_LOCATION'"
                  [iconClass]="'fas fa-plus'"
                  (onClick)="openNewLocationModal()"/>
</div>
<app-locations-table/>
